module.exports = __webpack_public_path__ + "img/no_exam_bg.cc44c324.png";